import { Component, ViewEncapsulation, Input, Output, EventEmitter, OnInit, OnChanges, ElementRef } from '@angular/core';

@Component({
    selector: 'tidy-toggle',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./toggle.component.scss'],
    templateUrl: 'toggle.component.html',
    standalone: false
})

export  class ToggleComponent implements OnInit, OnChanges {

  @Input() toggled = false;
  @Input() customClass = '';
  // Renders as disabled-but-interactive: the switch can never change state (click,
  // label or keyboard), yet taps still bubble so a wrapper can react (e.g. show a gate).
  @Input() disabled = false;
  @Output() toggleChanged = new EventEmitter<boolean>();

  selected: boolean;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.selected = this.toggled;
  }

  ngOnChanges() {
    this.selected = this.toggled;
  }

  onToggle() {
    this.toggleChanged.emit(this.selected);
    // Remove focus to clear the hover/focus effect after clicking
    setTimeout(() => {
      const button = this.el.nativeElement.querySelector('button');
      if (button) {
        button.blur();
      }
    }, 0);
  }

}
